<template>
    <div class="CarroselImagemCurso">
        <vueper-slides class="no-shadow carrosel"
                       :autoplay="lstImagens.length > 1"
                       :bulletsOutside="false"
                       :infinite="true"
                       :touchable="false"
                       :breakpoints="breakpoints"
                       >

            <template #arrow-left>
                <i class="fa-solid fa-chevron-left txt-size-15 txt-grey-1"></i>
            </template>

            <template #arrow-right>
                <i class="fa-solid fa-chevron-right txt-size-15"></i>
            </template>

            <vueper-slide v-for="(item,index) in lstImagens" :key="index" :title="index.toString()">
                <template #content>
                    <div class="vueperslide__content-wrapper" style="flex-direction: row; height: 125px;">
                        <div :style="'border-radius: 7px;width: 100%; height: 125px;background-size:cover;background-position: center; background-image: url('+item+')' ">
                        </div>
                        <!--<img class="img-fluid" :src="item" style="border-radius: 7px; height: 125px; " />-->
                    </div>
                </template>
            </vueper-slide>

        </vueper-slides>   
    </div>
    
</template>

<script>
    import { VueperSlides, VueperSlide } from 'vueperslides'
    import 'vueperslides/dist/vueperslides.css'

    export default {
        name: 'CarroselImagemCurso',
        components: { VueperSlides, VueperSlide },
        props: {
            lstImagens: {
                type: Array,
                required: true,
            },
        },
        data: function () {
            return {
                breakpoints: {
                    1800: {
                        fixedHeight: "125px",
                        slideRatio: 1 / 1
                    },
                    1400: {
                        fixedHeight: "125px",
                        slideRatio: 1 / 1
                    },
                    1300: {
                        fixedHeight: "125px",
                        slideRatio: 1 / 1
                    },
                    1200: {
                        fixedHeight: "125px",
                        slideRatio: 1 / 1
                    },
                    900: {
                        fixedHeight: "125px",
                        slideRatio: 1 / 1
                    },
                    800: {
                        fixedHeight: "125px",
                        slideRatio: 1 / 1
                    },
                    600: {
                        fixedHeight: "125px",
                        slideRatio: 1 / 1
                    },
                }, 
            }
        },
        methods: {
            
        },
        created: function () {
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .CarroselImagemCurso {
       

        .vueperslides__bullet .default {
            width: 8px !important;
            height: 8px !important;
        }
    }
    

</style>

